import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void) {
  window.addEventListener('scroll', onChange, { passive: true });
  return () => window.removeEventListener('scroll', onChange);
}

/**
 * True once the page is scrolled past `threshold` px. Subscribes to the browser with
 * useSyncExternalStore (react.dev's recommendation for external stores), and because the
 * snapshot is a boolean, components only re-render when it flips.
 */
export function useScrolled(threshold = 24) {
  return useSyncExternalStore(
    subscribe,
    () => window.scrollY > threshold,
    () => false,
  );
}
